import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
/**
 * 反爬滑动验证码,当状态码为-748时，跳转滑动验证码页面
 * 重写参考sentry https://github.com/getsentry/sentry-javascript/blob/5.15.5/packages/utils/src/instrument.ts
 */

var adapter;
var xhrproto;
var antiCheatSliderUrl;
if (typeof window !== 'undefined') {
  adapter = require('@zz-common/native-adapter')["default"]; // eslint-disable-line global-require
  //兼容测试小工具 https://gitlab.zhuanspirit.com/zz-fe-common/xhr-proxy-script/-/tree/master
  //window._zzrxhr?.prototype 为原生xhr
  xhrproto = window._zzrxhr && window._zzrxhr.prototype || window.XMLHttpRequest.prototype;
  antiCheatSliderUrl = 'https://m.zhuanzhuan.com/system/zzspampages/index.html#/anticheatslidercaptcha?source=h5';
}

/**
 * 重写对象上的属性
 * @method fill
 * @param {Object} source 需要被重写的对象
 * @param {String} name 需要被重写的属性
 * @param {Function} replacement 重写后的方法
 */
function fill(source, name, replacement) {
  if (!(name in source)) {
    return;
  }
  var original = source[name];
  var wrapped = replacement(original);
  source[name] = wrapped;
}

/**
 * 跳转反爬滑动验证码页
 * @method skipToSliderPage
 */
function skipToSliderPage() {
  if (native) {
    native.skipToUrl({
      targetUrl: antiCheatSliderUrl,
      needClose: '1'
    });
  }
}

/**
 * 初始化
 * @method antiCheatSliderCaptchaInit
 */
export function antiCheatSliderCaptchaInit() {
  fill(xhrproto, 'send', function (originalSend) {
    return function () {
      //类数组转数组
      var args = [].slice.call(arguments);
      //xhr为实例
      var xhr = this;
      xhr.addEventListener('readystatechange', function () {
        if (xhr.readyState === 4) {
          try {
            var response = _typeof(xhr.response) == 'object' ? xhr.response : JSON.parse(xhr.response);
            if (response && response.respCode == '-748') skipToSliderPage();
          } catch (e) {
            /* do nothing */
          }
        }
      });
      //执行原有send函数
      return originalSend.apply(this, args);
    };
  });
  fill(window, 'fetch', function (originalFetch) {
    return function () {
      var args = [].slice.call(arguments);
      return originalFetch.apply(window, args).then(function (response) {
        //respone.clone复制一个新的流，因为respone.json一个流只能使用一次
        //https://stackoverflow.com/questions/53511974/javascript-fetch-failed-to-execute-json-on-response-body-stream-is-locked
        response.clone().json().then(function (data) {
          if (data && data.respCode == '-748') skipToSliderPage();
        });
        return response;
      }, function (error) {
        throw error;
      });
    };
  });
}
export default antiCheatSliderCaptchaInit;